/* Cœura Quick Customize (9/18). A "Customize" button under each landing card opens a modal that mounts
   the SAME composer the PDP uses (CoeuraEngrave.Composer), lets the customer compose + add to cart, and
   on a pendant/locket add hands off to the necklace upsell (CoeuraChain) exactly like the PDP does.
   Data comes from window.__QS (built in collection.all-pieces.liquid). Reuses the global cart drawer.

   The modal DOM (and its <form>) is rebuilt on every open and removed on close. That is deliberate:
   the composer's attachForm() binds a submit listener to the form, so reusing one form across opens
   would leave the previous piece's listener attached and add TWO items on the next submit. */
(function () {
  'use strict';
  function CE() { return window.CoeuraEngrave; }
  function QS() { return window.__QS || {}; }
  /* The composer concatenates assetBase + a bare filename, so it needs the assets DIRECTORY,
     not this script's own URL — the same strip pdp.js / bench.js / begin.js do with theirs. */
  function assetDir() { return (QS().assetBase || '').replace(/coeura-quickshop\.js(\?.*)?$/, ''); }
  function tok(label) { return (CE() && CE().METAL_TOKEN && CE().METAL_TOKEN[label]) || null; }

  var els = null, composer = null, loadP = null;
  var curHandle = null, curProd = null, selected = [], globalsWired = false;
  /* A piece with a night face (the Moon) is never added without its night; until the composer has
     loaded we don't know whether this piece has one, so the add waits for it (ready). */
  var nightFace = false, ready = false;
  function hasNight() {
    try { return !!composer && composer.spec().placements.some(function (p) { return p.mode === 'date' && !!p.night; }); }
    catch (e) { return false; }
  }
  function nightMissing() { return nightFace && !hasNight(); }

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function buildModal() {
    var old = document.querySelector('.qs-overlay'); if (old) old.remove();
    var o = document.createElement('div');
    o.className = 'qs-overlay';
    o.innerHTML =
      '<div class="qs-modal" role="dialog" aria-modal="true" aria-label="Customize your piece">' +
        '<button type="button" class="qs-close" data-qs-close aria-label="Close">×</button>' +
        '<div class="qs-stage-wrap"><img class="qs-stage" data-qs-stage alt="">' +
          '<svg class="qs-overlay-svg" data-qs-osvg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice" aria-hidden="true"></svg></div>' +
        '<div class="qs-panel">' +
          '<span class="qs-eyebrow mono" data-qs-type></span>' +
          '<h2 class="qs-title" data-qs-title></h2>' +
          '<p class="qs-price mono" data-qs-price></p>' +
          '<form class="qs-form" data-qs-form>' +
            '<div class="qs-opts" data-qs-opts></div>' +
            '<div class="carigram qs-compose" data-carigram hidden></div>' +
            '<label class="qs-ack" data-qs-ack hidden><input type="checkbox" data-qs-ackcheck> Made by hand to order, for you alone. Full refund within 48 hours, or store credit within 14 days of arrival.</label>' +
            '<button type="submit" class="qs-add" data-qs-add>Add to bag</button>' +
            '<a class="qs-full mono" data-qs-full href="#">See the full piece →</a>' +
          '</form>' +
        '</div>' +
      '</div>';
    document.body.appendChild(o);
    var e = {
      overlay: o, modal: o.querySelector('.qs-modal'),
      stage: o.querySelector('[data-qs-stage]'), osvg: o.querySelector('[data-qs-osvg]'),
      type: o.querySelector('[data-qs-type]'), title: o.querySelector('[data-qs-title]'), price: o.querySelector('[data-qs-price]'),
      form: o.querySelector('[data-qs-form]'), opts: o.querySelector('[data-qs-opts]'), cari: o.querySelector('[data-carigram]'),
      ack: o.querySelector('[data-qs-ack]'), ackCheck: o.querySelector('[data-qs-ackcheck]'),
      add: o.querySelector('[data-qs-add]'), full: o.querySelector('[data-qs-full]')
    };
    o.addEventListener('click', function (ev) { if (ev.target === o || ev.target.closest('[data-qs-close]')) close(); });
    e.ackCheck.addEventListener('change', updateAdd);
    // Plain (uncomposed) add for THIS form; the composer's own handler owns a composed add.
    e.form.addEventListener('submit', function (ev) {
      if (composer && composer.started() && !nightMissing()) return;
      ev.preventDefault();
      if (!ready || nightMissing()) { updateAdd(); return; }
      var v = currentVariant(); if (!v || !v.avail) return;
      idInput().value = v.id;
      cartAdd(e.form).then(function () { afterAdd(curProd); }).catch(function () { location.href = curProd.url; });
    });
    return e;
  }

  /* ---- variant selection ---- */
  function currentVariant() {
    return (curProd.variants || []).find(function (v) {
      return v.opts.every(function (op, i) { return selected[i] == null || op === selected[i]; });
    }) || (curProd.variants || [])[0];
  }
  function currentMetal() {
    var v = currentVariant(), t = null;
    (v && v.opts || []).forEach(function (op) { if (tok(op)) t = tok(op); });
    return t;
  }
  function priceText() { var v = currentVariant(); return (v && v.priceText) || curProd.price || ''; }
  function idInput() {
    var i = els.form.querySelector('input[name="id"]');
    if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = 'id'; els.form.appendChild(i); }
    return i;
  }
  function syncVariant() {
    var v = currentVariant();
    idInput().value = v ? v.id : '';
    els.price.textContent = priceText();
    if (composer) composer.render(); else showBase();
    updateAdd();
  }
  function buildOpts() {
    els.opts.innerHTML = '';
    (curProd.options || []).forEach(function (name, oi) {
      var vals = [];
      (curProd.variants || []).forEach(function (v) { if (vals.indexOf(v.opts[oi]) === -1) vals.push(v.opts[oi]); });
      if (vals.length < 2) return;
      var row = document.createElement('div'); row.className = 'qs-opt';
      row.innerHTML = '<span class="qs-opt__label mono">' + esc(name) + '</span>';
      var wrap = document.createElement('div'); wrap.className = 'qs-opt__vals';
      vals.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'qs-chip'; b.textContent = val;
        b.setAttribute('aria-pressed', selected[oi] === val ? 'true' : 'false');
        b.addEventListener('click', function () {
          selected[oi] = val;
          wrap.querySelectorAll('.qs-chip').forEach(function (c) { c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
          syncVariant();
        });
        wrap.appendChild(b);
      });
      row.appendChild(wrap); els.opts.appendChild(row);
    });
  }
  function showBase() {
    if (!els || !els.stage) return;
    var v = currentVariant(), src = (v && v.image) || curProd.image || '';
    if (src && els.stage.getAttribute('src') !== src) els.stage.setAttribute('src', src);
    els.stage.style.visibility = '';
  }
  function updateAdd() {
    if (!els) return;
    var custom = composer && composer.started();
    els.ack.hidden = !custom;
    var v = currentVariant();
    if (!v || !v.avail) { els.add.disabled = true; els.add.textContent = 'Sold out'; return; }
    if (!ready) { els.add.disabled = true; return; }
    if (nightMissing()) { els.add.disabled = true; els.add.textContent = 'Choose your night'; return; }
    if (custom && !els.ackCheck.checked) { els.add.disabled = true; els.add.textContent = 'Confirm to add'; return; }
    els.add.disabled = false; els.add.textContent = 'Add to bag';
  }

  /* ---- add to cart + hand-off ---- */
  function cartAdd(form) {
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }
  function addComposed(prod) {
    return function (form) {              // composer's onSubmit: properties + proof already on the form
      if (nightMissing()) { updateAdd(); return; }
      cartAdd(form).then(function () { afterAdd(prod); }).catch(function () { location.href = prod.url; });
    };
  }
  function afterAdd(prod) {
    var metal = currentMetal();
    close();                                              // the quick menu goes away
    if (window.CoeuraCartDrawer) window.CoeuraCartDrawer.open({});
    var q = QS();
    var offersChain = (prod.type === 'Pendants' || prod.type === 'Lockets') && window.CoeuraChain && q.chains && q.chains.length;
    if (!offersChain) { if (window.CoeuraCartDrawer) window.CoeuraCartDrawer.refresh(); return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var has = (c.items || []).some(function (it) { return it.product_type === 'Carrier'; });
        if (has) { if (window.CoeuraCartDrawer) window.CoeuraCartDrawer.refresh(); return; }
        window.CoeuraChain.open({
          chains: q.chains, metal: metal, pieceTitle: prod.title,
          onAdded: function () { if (window.CoeuraCartDrawer) window.CoeuraCartDrawer.refresh(); }
        });
      }).catch(function () {});
  }

  /* ---- open / close ---- */
  function open(handle) {
    var q = QS(), prod = q.products && q.products[handle];
    if (!prod || !CE()) return;
    if (composer && composer.destroy) { composer.destroy(); composer = null; }
    curHandle = handle; curProd = prod;
    nightFace = false; ready = false;
    var fav = (prod.variants || []).filter(function (v) { return v.avail; })[0] || (prod.variants || [])[0];
    selected = fav ? fav.opts.slice() : (prod.options || []).map(function () { return null; });
    els = buildModal();                                  // fresh DOM + fresh listeners every open
    els.type.textContent = prod.type || '';
    els.title.textContent = prod.title || '';
    els.full.setAttribute('href', prod.url || '#');
    buildOpts();
    idInput().value = fav ? fav.id : '';
    showBase(); els.price.textContent = priceText();
    showModal();

    loadP = loadP || CE().load(q.carigramConfigUrl, q.paramsUrl);
    loadP.then(function (data) {
      if (curHandle !== handle || !els) return;          // a newer open won, or it was closed
      var product = CE().productFor(handle, data);
      ready = true;
      if (!product || !product.placements || !product.placements.length) { updateAdd(); return; }
      nightFace = product.placements.some(function (pl) {
        return pl.mode === 'date' || (pl.options || []).some(function (o) { return o.mode === 'date'; });
      });
      els.cari.hidden = false;
      composer = CE().Composer({
        ui: els.cari, stage: els.stage, overlay: els.osvg, product: product, assetBase: assetDir(),
        getMetal: currentMetal, getVariant: currentVariant,
        onChange: updateAdd, onShowBase: showBase, onSubmit: addComposed(prod),
        api: q.proofApi, meta: { handle: handle, productId: prod.productId, title: prod.title }
      });
      composer.attachForm(els.form, els.add);
      updateAdd();
    }).catch(function () { if (curHandle === handle) { ready = true; updateAdd(); } });
  }
  function showModal() {
    els.overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    els.modal.scrollTop = 0;
  }
  function close() {
    document.documentElement.style.overflow = '';
    if (composer && composer.destroy) { composer.destroy(); composer = null; }
    if (els && els.overlay) els.overlay.remove();
    els = null; curHandle = null;
  }

  /* ---- landing setup: only-customizable filter + carousel arrows ---- */
  function filterCards() {
    var q = QS(), cards = document.querySelectorAll('.ap-item[data-handle]');
    if (!CE() || !cards.length) return;
    (loadP || (loadP = CE().load(q.carigramConfigUrl, q.paramsUrl))).then(function (data) {
      cards.forEach(function (it) {
        var h = it.getAttribute('data-handle'), product = null;
        try { product = CE().productFor(h, data); } catch (e) {}
        if (!product || !product.placements || !product.placements.length) it.remove();
      });
      document.querySelectorAll('.ap-cat').forEach(function (sec) {
        var line = sec.querySelector('.ap-line');
        if (line && !line.querySelector('.ap-item')) sec.remove();
      });
      window.dispatchEvent(new Event('resize'));
    }).catch(function () {});
  }
  function initCarousels() {
    document.querySelectorAll('.ap-carousel').forEach(function (car) {
      var line = car.querySelector('.ap-line');
      if (!line || car.__wired) return;
      car.__wired = true;
      var prev = car.querySelector('[data-arrow="prev"]'), next = car.querySelector('[data-arrow="next"]');
      function stepBy() { return Math.max(240, line.clientWidth * 0.8); }
      function update() {
        var max = line.scrollWidth - line.clientWidth - 2;
        car.classList.toggle('ap-carousel--flat', line.scrollWidth <= line.clientWidth + 4);
        if (prev) prev.disabled = line.scrollLeft <= 2;
        if (next) next.disabled = line.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { line.scrollBy({ left: -stepBy(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { line.scrollBy({ left: stepBy(), behavior: 'smooth' }); });
      line.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function wireGlobals() {
    if (globalsWired) return; globalsWired = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qs-open]');
      if (!b) return; e.preventDefault(); open(b.getAttribute('data-qs-open'));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && els && !els.overlay.hidden) close(); });
  }
  function init() { wireGlobals(); initCarousels(); filterCards(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  window.CoeuraQuickShop = { open: open, close: close };
})();
